import { RouteConfig } from '../../routing/types'

const ROUTE: RouteConfig = {
  name: 'series-view',
  path: (params: { seriesSlug: string }) => `/series/${params.seriesSlug}`,
}

export default ROUTE
